import { render, staticRenderFns } from "./index.vue?vue&type=template&id=77032e6a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77032e6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/nisems/front/nisbos-front-admin/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77032e6a')) {
      api.createRecord('77032e6a', component.options)
    } else {
      api.reload('77032e6a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=77032e6a&scoped=true&", function () {
      api.rerender('77032e6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout2/index.vue"
export default component.exports